module.exports = __webpack_public_path__ + "img/cuowu.6f1753bc.png";